import { FC, SVGProps } from 'react';
import SvgImage from '../../assets/logo/streamVX.svg?react';

export const StreamVX: FC<SVGProps<SVGSVGElement>> = ({ color = '#000000', ...restProps }) => (
  <SvgImage color={color} {...restProps} />
);
